export default {
  DialogImage: state => state.dialogImage,
  Dialog: state => state.dialog
}
